module.exports = __webpack_public_path__ + "static/gridSize-c0d57cba459973cb493d01ddda054aa6.gif";